module.exports = __webpack_public_path__ + "img/shoppingMall.092f2650.png";